<script>
    export let url = "images/emptyprofile.svg"
    export let text = "email";
</script>

<div class="profile" title="Logout" on:click>
    <p>{text}</p>
    <img src={url} alt="Profile Avatar">
</div>

<style>
    img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-right: 0.2em;
    }

    .profile {
        margin: 0.1em 0 0 auto;
        display: flex;
        align-items: flex-end;
        font-family: "Work Sans", sans-serif;
        cursor: pointer;
    }
    

    p {
        color: var(--white);
        font-weight: 600;
        padding-right: 0.5em;
        line-height: 1.8
    }
</style>
